const SPACE_RE = /\s+/g;
const NAME_PART_RE = /^\p{L}+(?:['-]\p{L}+)*$/u;

export const normalizePersonFullName = (value) => String(value || '').trim().replace(SPACE_RE, ' ');

export const validatePersonFullName = (value, fieldLabel = 'Full Name') => {
  const normalized = normalizePersonFullName(value);
  if (!normalized) {
    return { valid: false, value: normalized, error: `${fieldLabel} is required` };
  }

  const parts = normalized.split(' ');
  if (parts.length < 2) {
    return { valid: false, value: normalized, error: 'Please enter at least first and last name' };
  }

  if (parts.some((part) => !NAME_PART_RE.test(part))) {
    return {
      valid: false,
      value: normalized,
      error: `${fieldLabel} can only contain letters, spaces, apostrophes, and hyphens`,
    };
  }

  return { valid: true, value: normalized, error: '' };
};
